import React, { useState, useRef } from 'react';
import { Form, Button, Overlay, Popover } from 'react-bootstrap';
import { ChromePicker } from 'react-color';

interface HexColorPickerProps {
  initialColor?: string;
  onChange?: (color: string) => void;
}

const HexColourPicker: React.FC<HexColorPickerProps> = ({ initialColor = '#ffffff', onChange }) => {
  const [color, setColor] = useState<string>(initialColor);
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const target = useRef(null);

  const handleColorChange = (newColor: any) => {
    const hex = newColor.hex;
    setColor(hex);
    onChange?.(hex);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^#[0-9A-F]{0,6}$/i.test(value)) {
      setColor(value);
      onChange?.(value);
    }
  };

  return (
    <Form.Group className="d-flex align-items-center gap-2">
      <Form.Control
        type="text"
        value={color}
        onChange={handleInputChange}
        placeholder="#RRGGBB"
        style={{ maxWidth: '120px' }}
      />
      <Button
        ref={target}
        variant="light"
        onClick={() => setShowPicker(!showPicker)}
        style={{
          backgroundColor: color,
          border: '1px solid #ccc',
          width: '30px',
          height: '30px',
          padding: 0,
        }}
      />
      <Overlay target={target.current} show={showPicker} placement="bottom">
        <Popover>
          <Popover.Body style={{ position: 'relative', paddingTop: '2rem' }}>
            <Button
              variant="link"
              size="sm"
              onClick={() => setShowPicker(false)}
              style={{
                position: 'absolute',
                top: '0.25rem',
                right: '0.5rem',
                fontSize: '1.2rem',
                lineHeight: '1',
                color: '#888',
                textDecoration: 'none',
              }}
              aria-label="Close color picker"
            >
              ×
            </Button>
            <ChromePicker color={color} onChange={handleColorChange} disableAlpha />
          </Popover.Body>
        </Popover>
      </Overlay>
    </Form.Group>
  );
};

export default HexColourPicker;